/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborCostLogDtoPage } from '../../models/labor-cost-log-dto-page';

export interface ListLaborCostLogs$Params {
  workPackageId?: string | null;
  userId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'minutes' | '-minutes' | 'comment' | '-comment' | 'fixedDate' | '-fixedDate' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'laborActivity' | '-laborActivity' | 'laborCost' | '-laborCost' | 'workPackage' | '-workPackage' | 'loggedBy' | '-loggedBy'>;
}

export function listLaborCostLogs(http: HttpClient, rootUrl: string, params?: ListLaborCostLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostLogDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listLaborCostLogs.PATH, 'get');
  if (params) {
    rb.query('workPackageId', params.workPackageId, {});
    rb.query('userId', params.userId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborCostLogDtoPage>;
    })
  );
}

listLaborCostLogs.PATH = '/v0/laborCostLogs';
